/**
 * Set-equality for two metadata-block field selections, insensitive to order and
 * duplicates. Used to make the phylocanvas renderer's restoreSavedMetadataBlocks()
 * idempotent: when the gear menu already shows exactly the requested blocks, the
 * re-tick / emit / refit is skipped. A renderer switch reaches a freshly built
 * (all-unchecked) menu so this never short-circuits a genuine restore; it only
 * collapses the second of the two calls the Tableau load path makes
 * (applyLoadedSettings plus the renderTree replay), keeping load a single apply.
 */
export function sameMetadataBlockSelection(
  a: readonly string[],
  b: readonly string[],
): boolean {
  const setA = new Set(a);
  const setB = new Set(b);
  if (setA.size !== setB.size) return false;
  for (const field of setA) {
    if (!setB.has(field)) return false;
  }
  return true;
}
